/**
 * Toast notification component
 */

import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  onClose: () => void;
  onClick?: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({ message, onClose, onClick, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="bg-green-950/90 border border-green-900/50 rounded-lg shadow-lg p-4 min-w-[300px] max-w-md backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <svg className="h-5 w-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-sm text-green-100 font-medium">{message}</p>
            {onClick && (
              <p className="text-xs text-green-300/70 mt-1">Click to view →</p>
            )}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="flex-shrink-0 text-green-300/60 hover:text-green-100 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
